<template>
  <div id="dg__contact" ref="contact" v-if="!checkValueNll">
    <p class="icon-box"><i class="icon">&#xe618;</i></p>
    <div class="content">
      <p class="t-[16] pb-[4]" v-if="value.customerServicePhone">客服热线：{{ value.customerServicePhone }}</p>
      <p class="t-[16]" v-if="value.customerServiceTime">服务时间：{{ value.customerServiceTime }}</p>
      <div class="flex text-center pt-[10]">
        <div class="pr-[20]" v-if="value.wechatPublicQrcode">
          <p><img :src="value.wechatPublicQrcode" class="img-code" alt="" /></p>
          <p class="pt-[4] t-[12]">公众号</p>
        </div>
        <div v-if="value.customerServiceWechatQrcode">
          <p><img :src="value.customerServiceWechatQrcode" class="img-code" alt="" /></p>
          <p class="pt-[4] t-[12]">客服微信</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// required
export default {
  name: "dg-contact",
  props: {
    top: String,
    right: String,

    value: {
      type: Object,
      default: () => {
        return {
          customerServicePhone: "400-816-1767", // 服务电话
          customerServiceTime: "工作日 9:00-18:00", // 服务时间
          // customerServiceWechatQrcode: "http://user.jjbaohan.com/static/img/wx_code.9d9333c.png", //客服二维码
          // wechatPublicQrcode: require("@/assets/img/official_code.png") // 公众号
          customerServiceWechatQrcode: require("@/assets/img/kefu-code.png"), //客服二维码
          wechatPublicQrcode: require("@/assets/img/gzh.png") // 公众号 
        };
      }
    },
    href: String
  },
  computed: {
    checkValueNll() {
      console.log(this.value);
      if (this.value && Object.keys(this.value).length == 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    if (this.top) {
      this.$refs["contact"].style.top = this.top;
    }
    if (this.right) {
      this.$refs["contact"].style.right = this.right;
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/assets/css/var.less';
#dg__contact {
  position: fixed;
  top: 25%;
  right: 20px;
  color: #192530;
  z-index: 10;
  &:hover .content {
    display: block;
  }
  .icon-box {
    width: 42px;
    height: 42px;
    background: @theme;
    border-radius: 100px;
    cursor: pointer;
    padding: 8px;
    i {
      color: #fff;
      font-size: 25px;
    }
  }
  .content {
    background: #fff;
    padding: 24px 30px;
    min-width: 290px;
    position: absolute;
    top: 0;
    right: 42px;
    border-radius: 4px;
    box-shadow: 0px 2px 6px 0px rgba(197, 197, 197, 0.22);
    display: none;
  }
  .img-code {
    width: 90px;
    height: 90px;
  }
}
</style>
 <style>.t-\[16\] {
    font-size: 16px
}
.pb-\[4\] {
    padding-bottom: 4px
}
.pt-\[10\] {
    padding-top: 10px
}
.pr-\[20\] {
    padding-right: 20px
}
.pt-\[4\] {
    padding-top: 4px
}
.t-\[12\] {
    font-size: 12px
}
.flex {
    display: flex
}
.text-center {
    text-align: center
}</style>